export const COOKIE_NAME_ACCESS_TOKEN = "REPOQA_ACCESS_TOKEN";
export const COOKIE_EPOCH_LAST_SECONDS = "REPOQA_EPOCH_LAST_SECONDS";
export const COOKIE_END_OF_DAY_LOCAL_EPOCH_SECONDS = "REPOQA_END_OF_DAY_LOCAL_EPOCH_SECONDS";

function setCookie(name, value, days = 356) {
    let expires = "";

    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Convert days to milliseconds
        expires = "; expires=" + date.toUTCString();
    }

    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return "";
}

function removeCookie(name) {
    setCookie(name, "", -1);
}

export function setAccessToken(accessTokenValue) {
    setCookie(COOKIE_NAME_ACCESS_TOKEN, accessTokenValue);
}

export function getAccessToken() {
    return getCookie(COOKIE_NAME_ACCESS_TOKEN);
}

export function removeAccessToken() {
    removeCookie(COOKIE_NAME_ACCESS_TOKEN);
}

function getOrDefaultIntCookie(name, default_on_missing) {
    let value = getCookie(name);
    if (value === "") {
        setCookie(name, default_on_missing.toString());
        value = default_on_missing;
    } else {
        value = parseInt(value);
    }
    return value;
}

function epochNow() {
    const epochInSeconds = Math.floor(Date.now() / 1000);
    return epochInSeconds;
}

export function isEpochToday(epoch) {
    const date = new Date(epoch * 1000);
    const today = new Date();
    return date.getDate() === today.getDate() &&
           date.getMonth() === today.getMonth() &&
           date.getFullYear() === today.getFullYear();
}

function getNext4PMEpoch() {
    const now = new Date();

    const targetTime = new Date(now);
    targetTime.setHours(16, 0, 0, 0);

    if (now > targetTime) {
        targetTime.setDate(now.getDate() + 1);
    }

    return Math.floor(targetTime.getTime() / 1000);
}

export function recordLastEpoch() {
    setCookie(COOKIE_EPOCH_LAST_SECONDS, epochNow().toString());
}

function isLastEpochToday() {
    const lastEpoch = getOrDefaultIntCookie(COOKIE_EPOCH_LAST_SECONDS, 0);
    return isEpochToday(lastEpoch);
}

export function isEOD() {
    //let nextEODEpoch = null;

    //const fallbackEpoch = getNext4PMEpoch();
    //const setEpoch = getOrDefaultIntCookie(COOKIE_END_OF_DAY_LOCAL_EPOCH_SECONDS, fallbackEpoch);
    //if (!isEpochToday(setEpoch)) {
    //    setCookie(COOKIE_END_OF_DAY_LOCAL_EPOCH_SECONDS, fallbackEpoch);
    //    nextEODEpoch = fallbackEpoch;
    //} else {
    //    nextEODEpoch = setEpoch;
    //}

    //return epochNow() >= nextEODEpoch && isLastEpochToday();
    return false;
}

export function delayEOD() {
    const currentDate = new Date();

    const newTime = new Date(currentDate.getTime() + 30 * 60 * 1000);

    let delayedEpoch = null;
    if (newTime.getDate() !== currentDate.getDate()) {
        delayedEpoch = getNext4PMEpoch();
    } else {
        delayedEpoch = Math.floor(newTime.getTime() / 1000);
    }

    setCookie(COOKIE_END_OF_DAY_LOCAL_EPOCH_SECONDS, delayedEpoch.toString());
}

export function resetEOD() {
    setCookie(COOKIE_END_OF_DAY_LOCAL_EPOCH_SECONDS, getNext4PMEpoch());
}

